import React from 'react';
import { useState, useEffect } from 'react';
import Section from 'components/Section';
import SectionHeader from 'components/SectionHeader';
import Pricing from 'components/Pricing';
import { motion } from 'framer-motion';
import Link from 'next/link';
import { SecureIcon, ArrowBubble, HeartIcon } from 'components/IconBlocks';
import NewsletterSection from './NewsletterSection';
import { useRouter } from 'next/router';
import FeaturesSection2 from './FeaturesSection2';
import useStore from './sharedCode/stores/store';
import { getUserIdData } from './platformFiles/webSpecific/dataFetches';
import { getFriendlyPlanId } from 'util/prices';

const FreeCard = ({ planActive }) => {
    return (
        <div
            className="column is-4"
            style={{
                opacity: planActive === 'trialLimitReached' ? '0.6' : '1',
                pointerEvents:
                    planActive === 'trialLimitReached' ? 'none' : 'auto',
                backgroundColor: '#FFF',
                margin: '24px',
                boxShadow:
                    '0 2px 12px -1px rgba(219,221,223,0.60), 0 35px 54px -26px rgba(148,155,162,0.70)',
                borderRadius: '24px',
                padding: '3rem',
                minWidth: '320px'
            }}
        >
            <h2 style={{ fontWeight: '500', fontSize: '24px' }}>Trial</h2>
            <div
                style={{
                    height: '98px',
                    alignItems: 'center',
                    marginBottom: '8px'
                }}
            >
                <h1
                    style={{
                        fontWeight: '600',
                        fontSize: '54px',
                        paddingTop: '10px'
                    }}
                >
                    Free
                </h1>
            </div>
            <FeatureRow
                color={'#1BD36E'}
                textColor={'#687482'}
                featureText={'All basic features'}
            />
            <FeatureRow
                color={'#1BD36E'}
                textColor={'#687482'}
                featureText={'Up to 30 saves'}
            />
            <FeatureRow
                color={'#1BD36E'}
                textColor={'#687482'}
                featureText={'Unlimited time'}
            />
            <FeatureRow
                color={'#1BD36E'}
                textColor={'#687482'}
                featureText={'No account needed'}
            />
            <Link href="/guide/getting-started" passHref>
                <ChooseButton
                    cta={'Get started'}
                    textColor={'#565D65'}
                    bg={'#F3F3F3'}
                />
            </Link>
        </div>
    );
};

const Card = ({ planActive, isOn, authUser, plan, userPlan }) => {
    return (
        <div
            className="column is-4"
            style={{
                //Blue
                backgroundImage:
                    'linear-gradient(151deg, #00B0FF 1%, #0078FF 92%)',
                //Green:
                //backgroundImage: "linear-gradient(-46deg, #0D77AF 0%, #0CD77D 100%)",
                margin: '24px',
                //Blue Shadow
                boxShadow:
                    '0 28px 54px -10px rgba(0,120,255,0.50), 0 0 64px 0 rgba(0,120,255,0.10)',
                //Green Shadow
                //boxShadow: "0 28px 54px -10px rgba(25,113,113,0.50), 0 0 64px 0 rgba(25,113,113,0.10)",
                borderRadius: '24px',
                padding: '3rem',
                minWidth: '320px'
            }}
        >
            <h2
                className="isFFF"
                style={{
                    fontWeight: '500',
                    fontSize: '24px',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                Pro plan{' '}
                {(userPlan === 'pro' || userPlan === 'proyear') && (
                    <span
                        className="tag is-primary is-medium isFFF"
                        style={{
                            backgroundColor: 'rgb(255 255 255 / 0.2)',
                            color: '#FFF !important',
                            fontWeight: '600',
                            marginLeft: '4px'
                        }}
                    >
                        ACTIVE
                    </span>
                )}
            </h2>
            <div
                // animate={{}}
                style={{
                    height: '98px',
                    alignItems: 'center',
                    marginBottom: '8px'
                }}
            >
                <h1
                    className="isFFF"
                    style={{
                        fontWeight: '600',
                        fontSize: '36px',
                        color: '#FFF !important',
                        letterSpacing: '1.32px'
                    }}
                >
                    <span style={{ fontSize: '36px' }}>$</span>
                    <span style={{ fontSize: '64px', letterSpacing: '0px' }}>
                        {isOn ? '6' : '8'}
                    </span>
                    <span style={{ fontSize: '36px', opacity: '0.7' }}>
                        /mo
                    </span>
                </h1>
            </div>
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'Unlimited items saved'}
            />
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'Multiple workspaces'}
            />
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'Daily backups'}
            />
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'Reminders'}
                //newFeature
            />
            <Link
                href={
                    authUser
                        ? `/purchase/${plan}`
                        : `/auth/signup?next=/purchase/${plan}`
                }
                passHref
            >
                <ChooseButton
                    cta={'Upgrade now'}
                    textColor={'#FFF'}
                    bg={'rgb(255, 255, 255, 0.2)'}
                />
            </Link>
        </div>
    );
};

const TeamCard = ({ authUser, plan, isOn, userPlan }) => {
    return (
        <div
            className="column is-4"
            style={{
                backgroundImage:
                    //'linear-gradient(134deg, #016AEA 0%, #BA0086 100%)',
                    'linear-gradient(-46deg, #0D77AF 0%, #0CD77D 100%)',
                margin: '24px',
                boxShadow:
                    //'0 28px 54px -10px rgba(80,25,113,0.50), inset 0 0 64px 0 rgba(59,40,135,0.10)',
                    '0 28px 54px -10px rgba(25,113,113,0.50), inset 0 0 64px 0 rgba(25,113,113,0.10)',
                borderRadius: '24px',
                padding: '3rem',
                minWidth: '320px',
                position: 'relative'
            }}
        >
            <p
                style={{
                    fontWeight: '500',
                    fontSize: '24px',
                    color: '#FFF'
                }}
            >
                Team plan{" "}
                {(userPlan === 'team' || userPlan === 'teamyear') && (
                    <span
                        className="tag is-primary is-medium isFFF"
                        style={{
                            backgroundColor: 'rgb(255 255 255 / 0.2)',
                            color: '#FFF !important',
                            fontWeight: '600',
                            marginLeft: '4px'
                        }}
                    >
                        ACTIVE
                    </span>
                )}
            </p>
            <div
                // animate={{}}
                style={{
                    height: '98px',
                    alignItems: 'center',
                    marginBottom: '8px'
                }}
            >
                <p
                    style={{
                        fontWeight: '600',
                        fontSize: '36px',
                        color: '#FFF',
                        letterSpacing: '1.32px'
                    }}
                >
                    <span style={{ fontSize: '36px', color: '#FFF' }}>$</span>
                    <span style={{ fontSize: '64px', color: '#FFF' }}>
                        {isOn ? '15' : '21'}
                    </span>
                    <span style={{ fontSize: '36px', color: '#FFF', opacity: '0.7' }}>
                        /mo
                    </span>
                </p>
            </div>
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'3 seats'}
                subtitle={isOn ? '(+$5 per seat)' : '(+$7 per seat)'}
            />
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'All Pro features'}
            />
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'Team management area'}
            />
            <FeatureRow
                color={'#FFF'}
                textColor={'#FFF'}
                featureText={'Priority support'}
            />
            <Link
                href={
                    authUser
                        ? `/purchase/${plan}`
                        : `/auth/signup?next=/purchase/${plan}`
                }
                passHref
            >
                <ChooseButton
                    cta={'Upgrade now'}
                    textColor={'#FFF'}
                    bg={'rgb(255, 255, 255, 0.2)'}
                />
            </Link>

            <div
                style={{
                    position: 'absolute',
                    top: '-43px',
                    left: "82px",
                    padding: '16px',
                    background: '#FFF',
                    borderRadius: '22px',
                    boxShadow:
                        '0 36px 44px -20px rgb(29 29 29 / 50%), rgba(59, 40, 135, 0.1) -2px -2px 1px 0px inset'
                }}
            >
                <p
                    style={{
                        maxWidth: '211px',
                        fontSize: '14px',
                        fontWeight: '600'
                    }}
                >
                    Get your team on the{' '}
                    <span style={{ color: '#2381ed', cursor: 'pointer' }}>
                        <Link href="/guide/share-workspaces">same page</Link>
                    </span>{' '}
                    with our brand new plan
                </p>
            </div>
            <div
                style={{
                    position: 'absolute',
                    top: '22px',
                    left: '124px',
                    height: '16px',
                    width: '16px',
                    transform: 'rotate(45deg)',
                    background: '#FFF',
                    borderRadius: '2px',
                    boxShadow: "rgba(59, 40, 135, 0.1) -2px -2px 1px 0px inset"
                }}
            />
        </div>
    );
};

const FAQitem = ({
    icon,
    question,
    answer,
    stripeUrl,
    paymentIcons,
    middle,
    affiliateUrl,
    ...props
}: any) => {
    return (
        <>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        height: '44px',
                        minWidth: '44px',
                        background: '#F4F5F7',
                        backgroundImage:
                            'linear-gradient(180deg, #F4F5F7 0%, #ECEDF2 100%)',
                        boxShadow:
                            '0 1px 3px 0 rgba(103,109,132,0.30), inset 1px 1px 1px 0 rgba(255,255,255,0.95), inset -1px -1px 1px 0 rgb(192 194 197)',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '2rem'
                        //marginTop: "-6px",
                    }}
                >
                    {props.children}
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: middle ? '200px' : '245px'
                    }}
                >
                    <h3
                        className="has-text-weight-bold"
                        style={{ fontSize: '1.25rem' }}
                    >
                        {question}
                    </h3>
                    <p
                        className="subtitle"
                        style={{
                            fontFamily: 'Rubik, sans-serif',
                            color: '#4A545E',
                            fontSize: '1rem',
                            lineHeight: '1.5',
                            paddingBottom: paymentIcons ? '0rem' : '2rem',
                            marginTop: '1.2rem',
                            marginBottom: '0px',
                            minHeight: '104px'
                        }}
                    >
                        {answer}{' '}
                        {stripeUrl && (
                            <a
                                href="https://stripe.com/"
                                //@ts-ignore
                                alt="Stripe homepage"
                                style={{ color: 'rgb(0, 120, 255)' }}
                            >
                                stripe.com
                            </a>
                        )}
                        {affiliateUrl && (
                            <a
                                href="https://tabextend.getrewardful.com/"
                                //@ts-ignore
                                alt="Affiliate portal"
                                style={{ color: 'rgb(0, 120, 255)' }}
                            >
                                tabextend.getrewardful.com
                            </a>
                        )}
                    </p>
                    {paymentIcons && (
                        <div
                            //className="flexAndBlock"
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                paddingBottom: '2rem',
                                marginTop: '-1rem',
                                alignItems: 'center'
                            }}
                        >
                            <Py1 />
                            <Py2 />
                            <Py3 />
                            <Py4 />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

function PricingSection(props) {
    const [isOn, setIsOn] = useState(false);
    const toggleSwitch = () => setIsOn(!isOn);
    const plan = isOn ? 'proyear' : 'pro';
    const teamPlan = isOn ? 'teamyear' : 'team';

    const disabled = { pointerEvents: 'none', opacity: '0.65' };

    //const browser = isChrome ? "Chrome" : isFirefox ? "Firefox" :  isSafari ? "Safari" : isEdge ? "Edge" : isOpera ? "Opera" : "Other"

    let authUser = useStore((state) => state.authUser);
    const router = useRouter();

    const [userPlan, setUserPlan] = useState<any>({});
    

    const fetchUserData = async () => {
        await getUserIdData('users').then((data) => {
            if ((data?.docData as any)?.stripePriceId && (data?.docData as any)?.stripeSubscriptionStatus === 'active') {
                console.log('stripePriceId', (data?.docData as any)?.stripePriceId);
                let friendlyPlanId = getFriendlyPlanId((data?.docData as any)?.stripePriceId);
                setUserPlan(friendlyPlanId);
            } else {
                setUserPlan('free');
            }
        });
    };

    useEffect(() => {
        if (authUser) {
            fetchUserData();
        }
    }, [authUser]);

    const [planActive, setPlanActive] = useState(false);

    /* useEffect(() => {
        if (authUser !== null) {
            if (authUser.userPlan === 'trialLimitReached') {
                //@ts-ignore
                setPlanActive('trialLimitReached');
            }
            if (authUser.userPlan === 'active') {
                //@ts-ignore
                setPlanActive('active');
            }
        }
    }, [authUser]); */

    return (
        <>
            <Section
                id="pricing"
                color={props.color}
                size={props.size}
                backgroundImage={props.backgroundImage}
                backgroundImageOpacity={props.backgroundImageOpacity}
            >
                <div className="container">
                    <SectionHeader
                        title={props.title}
                        subtitle={props.subtitle}
                        size={1}
                        spaced={true}
                        className="has-text-centered"
                    />
                    <div className="columns is-centered">
                        <FreeCard planActive={planActive} />
                        <Card
                            planActive={planActive}
                            isOn={isOn}
                            authUser={authUser}
                            plan={plan}
                            userPlan={userPlan}
                        />
                        <TeamCard authUser={authUser} plan={teamPlan} isOn={isOn} userPlan={userPlan} />
                    </div>
                    <div className="columns is-centered">
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginTop: '44px',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}
                            className="priceSwitchContainer"
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <p
                                    className="switchText"
                                    style={{
                                        marginRight: '12px',
                                        fontWeight: '500',
                                        color: '#687482',
                                        letterSpacing: '0.24px',
                                        fontSize: '14px'
                                    }}
                                >
                                    BILLING: MONTHLY
                                </p>
                                <Switch
                                    isOn={isOn}
                                    toggleSwitch={toggleSwitch}
                                />
                                <p
                                    className="switchText"
                                    style={{
                                        marginLeft: '12px',
                                        fontWeight: '500',
                                        color: '#687482',
                                        letterSpacing: '0.24px',
                                        fontSize: '14px'
                                    }}
                                >
                                    YEARLY
                                </p>
                                <span
                                    className="tag is-primary is-medium switchText"
                                    style={{
                                        backgroundColor: '#FED844',
                                        color: '#6D4108',
                                        fontWeight: '600',
                                        marginLeft: '8px',
                                        fontSize: '13px'
                                    }}
                                >
                                    Save 25%
                                </span>
                            </div>
                        </div>
                    </div>
                    <FeaturesSection2
                        size="medium"
                        backgroundImage=""
                        backgroundImageOpacity={1}
                    ></FeaturesSection2>
                    <h2
                        style={{
                            fontSize: '2rem',
                            fontWeight: '600',
                            textAlign: 'left',
                            marginBottom: '5rem',
                            marginTop: '2rem',
                            paddingLeft: '3rem',
                            paddingRight: '3rem'
                        }}
                    >
                        Frequently Asked Questions
                    </h2>
                    <div
                        className="columns"
                        style={{
                            paddingLeft: '3rem',
                            paddingRight: '3rem'
                            //border: "1px dashed rgb(195, 201, 210)",
                            //borderRadius: "12px",
                        }}
                    >
                        <div
                            className="column"
                            style={{
                                marginRight: '2rem',
                                paddingRight: '2rem'
                            }}
                        >
                            <FAQitem
                                paymentIcons={true}
                                question={
                                    'What forms of payment do you accept?'
                                }
                                answer={
                                    'We are powered by Stripe, which accepts all major debit and credit card payments (Visa, American Express, Mastercard), as well as other local payment solutions.'
                                }
                            >
                                <CreditIcon IconColor={'#353C49'} />
                            </FAQitem>
                            <FAQitem
                                question={'Will I be charged any sales-tax?'}
                                answer={
                                    "tabExtend covers the local sales tax on our end, so you won't need to pay any additional sales tax. Team plans exclude VAT."
                                }
                                middle={true}
                            >
                                <DollarIcon IconColor={'#353C49'} />
                            </FAQitem>
                            {/* <FAQitem
                question={
                  "Why should I pay for this when other tools are free?"
                }
                answer={
                  "We are a bootstrapped company and to cover our cost and keep development going we have chosen a paid plan over selling data, showing advertisement, or implementing malicious third-party code into the product. If tabExtend saves you only a few minutes a day it will quickly add up and benefit you enough to hopefully be worth the price."
                }
              >
                <HeartIcon
                  IconColor={"#353C49"}
                  height={"28px"}
                  width={"28px"}
                />
              </FAQitem> */}
                            <FAQitem
                                question={'Do you have a affiliate program?'}
                                answer={
                                    'Yes, earn a 25% commission on the revenue from everyone you refer to tabExtend through our affiliate program. Join us today and learn more at '
                                }
                                affiliateUrl={true}
                            >
                                <HeartIcon
                                    IconColor={'#353C49'}
                                    height={'28px'}
                                    width={'28px'}
                                />
                            </FAQitem>
                        </div>
                        <div className="column">
                            <FAQitem
                                question={'Who stores my credit card number?'}
                                answer={
                                    'All payments and security measures are managed by Stripe. We never have access to or handle your credit card details. Stripe is PCI-certified, and card numbers are encrypted using AES-256. Learn more at '
                                }
                                stripeUrl={true}
                            >
                                <SecureIcon
                                    IconColor={'#353C49'}
                                    height={'28px'}
                                    width={'28px'}
                                />
                            </FAQitem>
                            <FAQitem
                                question={'What is your refund policy?'}
                                answer={
                                    'Should you wish to cancel your plan for any reason, we offer a full refund within 30 days.'
                                }
                                middle={true}
                            >
                                <TagIcon IconColor={'#353C49'} />
                            </FAQitem>
                            <FAQitem
                                question={
                                    'Do you offer discounts to students or teachers?'
                                }
                                answer={
                                    'Yes, if you are a student or a teacher and you want a discount please contact us and we will set you up.'
                                }
                            >
                                <BookIcon color={'#353C49'} />
                            </FAQitem>
                        </div>
                    </div>
                    <div className="columns is-centered"></div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '4rem',
                        marginTop: '1rem'
                    }}
                >
                    <blockquote style={{ margin: 'auto' }}>
                        <h2
                            className={
                                'title is-1 is-size-2-mobile is-spaced prodquote'
                            }
                            style={{
                                marginTop: '6rem',
                                textAlign: 'center',
                                fontStyle: 'italic',
                                maxWidth: '720px',
                                lineHeight: '1.54',
                                fontFamily: 'Rubik, sans-serif',
                                fontWeight: '600',
                                fontSize: '28px'
                            }}
                        >
                            “Productivity is never an accident. It is always the
                            result of a commitment to excellence, intelligent
                            planning, and focused effort.”
                        </h2>
                        <p
                            style={{
                                textAlign: 'center',
                                margin: 'auto',
                                fontSize: '1.15rem',
                                fontFamily: 'Rubik, sans-serif',
                                marginTop: '1rem',
                                marginBottom: '-2rem'
                            }}
                        >
                            — Paul J. Meyer
                        </p>
                    </blockquote>
                </div>
            </Section>
        </>
    );
}

export default PricingSection;

const CheckIcon = ({ color }) => {
    return (
        <svg
            height="26"
            width="26"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
};
const BookIcon = ({ color }) => {
    return (
        <svg
            height="26"
            width="26"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: 'auto' }}
        >
            <path
                d="M9 4.80423C7.9428 4.28906 6.75516 4 5.5 4C4.24484 4 3.0572 4.28906 2 4.80423V14.8042C3.0572 14.2891 4.24484 14 5.5 14C7.1686 14 8.71789 14.5108 10 15.3847C11.2821 14.5108 12.8314 14 14.5 14C15.7552 14 16.9428 14.2891 18 14.8042V4.80423C16.9428 4.28906 15.7552 4 14.5 4C13.2448 4 12.0572 4.28906 11 4.80423V12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12V4.80423Z"
                fill={color}
            />
        </svg>
    );
};

const Py2 = () => {
    return (
        <svg
            height="16"
            width="85"
            fill="none"
            viewBox="0 0 85 16"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: '12px' }}
        >
            <g fill="none" fillRule="evenodd">
                <g stroke="#427FBC" strokeLinecap="square">
                    <path
                        strokeOpacity=".1"
                        d="M1003.5-6508V7929"
                        fill="var(--paymentLogoColor, null)"
                    ></path>
                    <path
                        strokeOpacity=".15"
                        strokeDasharray="3,5"
                        d="M733.5-6508V7929M463.5-6508V7929M193.5-6508V7929"
                        fill="var(--paymentLogoColor, null)"
                    ></path>
                    <path
                        strokeOpacity=".1"
                        d="M-76.5-6508V7929"
                        fill="var(--paymentLogoColor, null)"
                    ></path>
                </g>
                <g fillRule="nonzero">
                    <path
                        d="M36.1 4.99c-.6 0-1.4.2-1.8.9-.3-.5-.9-.9-1.7-.9-.5 0-1.1.1-1.5.7v-.6H30v4.9h1.1v-2.7c0-.8.6-1.3 1.3-1.3.7 0 1.1.5 1.1 1.3v2.7h1.1v-2.7c0-.8.6-1.3 1.3-1.3.7 0 1.1.5 1.1 1.3v2.7h1.09v-3c0-1.2-.8-2-2-2zm6.88.8c-.3-.4-.8-.7-1.5-.7-1.4 0-2.4 1.1-2.4 2.6s1.1 2.6 2.4 2.6c.7 0 1.2-.3 1.5-.7v.4h1.1v-4.9h-1.1v.7zm-1.4 3.4c-.9 0-1.5-.7-1.5-1.6 0-.9.6-1.6 1.5-1.6s1.5.7 1.5 1.6c0 .9-.6 1.6-1.5 1.6zm6.2-2.1l-.5-.1c-.4-.1-.8-.2-.8-.5s.3-.6.9-.6c.6 0 1.2.2 1.5.4l.5-.8c-.5-.3-1.2-.5-2-.5-1.2 0-2 .6-2 1.6 0 .8.6 1.3 1.6 1.4l.5.1c.6.1.8.3.8.5 0 .4-.4.6-1.1.6-.8 0-1.3-.2-1.6-.5l-.5.8c.7.5 1.6.6 2.1.6 1.4 0 2.2-.7 2.2-1.6.1-.8-.5-1.2-1.6-1.4zm5.4 2.1c-.4 0-.8-.3-.8-.9v-2.1h1.9v-1h-1.9v-1.5h-1.1v1.5h-1v1h1v2.1c0 1.3.6 1.9 1.7 1.9.6 0 1.1-.2 1.5-.5l-.4-.9c-.3.2-.6.4-.9.4zm4.39-4.2c-1.4 0-2.4 1-2.4 2.6s1 2.6 2.5 2.6c.7 0 1.4-.2 2-.7l-.5-.8c-.4.3-.9.5-1.4.5-.7 0-1.3-.4-1.4-1.2h3.6v-.4c-.1-1.5-1-2.6-2.4-2.6zm-1.3 2.2c.1-.7.5-1.2 1.3-1.2.7 0 1.1.4 1.2 1.2h-2.5zm5.9-1.5v-.6h-1.1v4.9h1.1v-2.7c0-.8.5-1.3 1.2-1.3.3 0 .6.1.79.2l.3-1.1c-.2-.1-.5-.1-.8-.1-.7 0-1.2.2-1.5.7zm4.99.3c.5 0 .8.2 1.2.5l.7-.7c-.4-.5-1.1-.8-1.8-.8-1.5 0-2.6 1.1-2.6 2.6s1 2.6 2.6 2.6c.7 0 1.4-.3 1.8-.8l-.7-.7c-.3.3-.7.5-1.2.5-.8 0-1.4-.6-1.4-1.6s.6-1.6 1.4-1.6zm6.39-.2c-.3-.4-.8-.7-1.5-.7-1.4 0-2.4 1.1-2.4 2.6s1.1 2.6 2.4 2.6c.7 0 1.2-.3 1.5-.7v.4h1.1v-4.9h-1.1v.7zm-1.4 3.4c-.9 0-1.5-.7-1.5-1.6 0-.9.6-1.6 1.5-1.6s1.5.7 1.5 1.6c0 .9-.6 1.6-1.5 1.6zm5.1-3.5v-.6h-1.1v4.9h1.1v-2.7c0-.8.5-1.3 1.2-1.3.3 0 .6.1.8.2l.3-1.1c-.2-.1-.5-.1-.8-.1-.7 0-1.2.2-1.5.7zm6.39-3v3c-.3-.4-.8-.7-1.5-.7-1.4 0-2.4 1.1-2.4 2.6s1.1 2.6 2.4 2.6c.7 0 1.2-.3 1.5-.7v.5h1.1v-7.3h-1.1zm-1.4 6.5c-.9 0-1.5-.7-1.5-1.6 0-.9.6-1.6 1.5-1.6s1.5.7 1.5 1.6c0 .9-.6 1.6-1.5 1.6z"
                        fill="var(--paymentLogoColor, #0A2540)"
                    ></path>
                    <path
                        d="M10.12 7.59c0-2.4 1.1-4.5 2.8-5.9-1.3-1-2.9-1.6-4.6-1.6C4.22 0 .93 3.4.93 7.6s3.3 7.59 7.4 7.59c1.7 0 3.29-.6 4.59-1.6a7.96 7.96 0 0 1-2.8-6z"
                        fill="var(--paymentLogoColor, #ED0006)"
                    ></path>
                    <path
                        d="M17.51 0c-1.7 0-3.3.6-4.6 1.6a7.6 7.6 0 0 1 0 11.78c1.3 1 2.9 1.6 4.6 1.6 4.1 0 7.4-3.4 7.4-7.5C24.9 3.4 21.6 0 17.5 0z"
                        fill="var(--paymentLogoColor, #F9A000)"
                    ></path>
                    <path
                        d="M15.71 7.59c0-2.4-1.1-4.5-2.8-5.9-1.7 1.4-3.79 3.5-3.79 5.9 0 2.4 2 4.5 3.8 5.89a7.6 7.6 0 0 0 2.8-5.9z"
                        fill="var(--paymentLogoColor, #FF5D00)"
                    ></path>
                </g>
            </g>
        </svg>
    );
};
const Py1 = () => {
    return (
        <svg
            height="42"
            width="24"
            fill="none"
            viewBox="0 0 42 24"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: '12px' }}
        >
            <path
                fill="var(--paymentLogoColor, #191E70)"
                d="M20.8 5.31L17.97 18.9h-3.43l2.83-13.58h3.43zm14.23 8.78l1.82-5.12 1.01 5.12h-2.83zm3.84 4.8H42L39.27 5.31h-2.92c-.61 0-1.22.42-1.42 1.05l-5.05 12.53h3.54l.7-1.98h4.35l.4 1.98zm-8.88-4.49c0-3.55-4.75-3.76-4.75-5.33.1-.73.7-1.15 1.41-1.15 1.11-.1 2.33.1 3.34.63l.6-2.92A8.36 8.36 0 0 0 27.46 5c-3.33 0-5.75 1.88-5.75 4.5 0 1.98 1.71 3.02 2.92 3.65 1.32.62 1.82 1.04 1.72 1.67 0 .94-1 1.36-2.02 1.36a8.37 8.37 0 0 1-3.53-.84l-.6 2.92c1.2.53 2.52.74 3.73.74 3.73.1 6.06-1.78 6.06-4.6zM15.95 5.31L10.5 18.9H6.87L4.14 8.03c0-.52-.4-.94-.8-1.15A11.5 11.5 0 0 0 0 5.73l.1-.42h5.76c.8 0 1.4.63 1.51 1.36l1.41 7.83 3.64-9.19h3.53z"
            ></path>
        </svg>
    );
};
const Py3 = () => {
    return (
        <svg
            height="24"
            width="72"
            fill="none"
            viewBox="0 0 72 24"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: '12px' }}
        >
            <g fill="none" fillRule="evenodd">
                <path
                    d="M0 0h72v24H0z"
                    fill="var(--paymentLogoColor, null)"
                ></path>
                <path
                    fill="var(--paymentLogoColor, #000)"
                    fillRule="nonzero"
                    d="M69.871 13.545a.318.318 0 0 1 .296.439.32.32 0 0 1-.296.193.322.322 0 0 1-.299-.193.316.316 0 0 1 .3-.439zm0 .561a.235.235 0 0 0 .173-.07.247.247 0 0 0-.077-.401.239.239 0 0 0-.096-.02.247.247 0 0 0-.177.42.247.247 0 0 0 .177.071zm.02-.394a.133.133 0 0 1 .086.024.084.084 0 0 1 .032.069.079.079 0 0 1-.025.06.116.116 0 0 1-.069.03l.096.11h-.075l-.09-.11h-.029v.11h-.062v-.293h.135zm-.074.054v.079h.073a.07.07 0 0 0 .04 0 .033.033 0 0 0 .014-.03.033.033 0 0 0-.014-.029.07.07 0 0 0-.04 0l-.073-.02zm-32.74.236v-3.117c0-1.176-.75-1.968-1.958-1.978-.7-.046-1.37.294-1.748.885a1.827 1.827 0 0 0-1.644-.885 1.646 1.646 0 0 0-1.454.74v-.624H29.19v4.975h1.093v-2.751c0-.865.478-1.322 1.218-1.322s1.083.468 1.083 1.311v2.769h1.095v-2.758c0-.865.499-1.322 1.218-1.322s1.093.468 1.093 1.311v2.769l1.087-.003zm6.1-2.493V9.015h-1.083v.604a1.887 1.887 0 0 0-1.572-.729c-1.394 0-2.493 1.093-2.493 2.612 0 1.52 1.093 2.613 2.493 2.613a1.887 1.887 0 0 0 1.572-.73v.603h1.082v-2.48zm-4.028 0c0-.875.571-1.592 1.509-1.592.895 0 1.498.688 1.498 1.592 0 .904-.603 1.591-1.498 1.591-.938.009-1.511-.708-1.511-1.583l.002-.008zM66.34 8.89c.367-.001.73.07 1.069.208a2.52 2.52 0 0 1 1.411 1.382c.27.666.27 1.412 0 2.078a2.519 2.519 0 0 1-1.411 1.382 2.949 2.949 0 0 1-2.137 0 2.575 2.575 0 0 1-.848-.55c-.24-.238-.43-.52-.559-.832a2.766 2.766 0 0 1 0-2.078 2.54 2.54 0 0 1 1.407-1.382c.34-.136.703-.204 1.068-.2V8.89zm0 1.025a1.617 1.617 0 0 0-.623.116 1.455 1.455 0 0 0-.82.831 1.81 1.81 0 0 0 0 1.295 1.466 1.466 0 0 0 .822.831c.398.156.84.156 1.237 0a1.492 1.492 0 0 0 .827-.831 1.81 1.81 0 0 0 0-1.295 1.51 1.51 0 0 0-.33-.505 1.492 1.492 0 0 0-1.113-.434v-.008zm-17.282 1.602c0-1.55-.969-2.612-2.363-2.612-1.455 0-2.477 1.062-2.477 2.612 0 1.581 1.062 2.612 2.55 2.612a3.024 3.024 0 0 0 2.04-.698l-.53-.802a2.38 2.38 0 0 1-1.454.52c-.699 0-1.332-.323-1.488-1.219h3.695c.027-.133.027-.268.027-.413zm-3.706-.437c.115-.719.551-1.207 1.322-1.207.698 0 1.145.436 1.26 1.207h-2.582zm8.729-1.662a3.72 3.72 0 0 0-2.03-.52c-1.26 0-2.079.603-2.079 1.592 0 .813.603 1.312 1.717 1.467l.509.073c.592.083.875.24.875.52 0 .384-.395.602-1.135.602a2.652 2.652 0 0 1-1.662-.52l-.51.845a3.59 3.59 0 0 0 2.156.646c1.436 0 2.27-.678 2.27-1.623 0-.875-.658-1.332-1.738-1.488l-.51-.073c-.467-.062-.843-.156-.843-.488 0-.364.353-.584.947-.584a3.198 3.198 0 0 1 1.582.432l.45-.881zm4.734-.395h-1.768V7.514h-1.094v1.509h-1.01v.99h1.01v2.269c0 1.155.447 1.843 1.727 1.843.479.002.947-.132 1.353-.384l-.311-.927a2 2 0 0 1-.958.28c-.54 0-.72-.332-.72-.831v-2.245h1.782l-.01-.995zm3.741-.125a1.467 1.467 0 0 0-1.311.73v-.605h-1.073v4.975h1.083v-2.782c0-.832.353-1.28 1.062-1.28.232-.004.462.038.677.124l.333-1.02a2.313 2.313 0 0 0-.771-.135v-.007z"
                ></path>
                <path
                    fill="var(--paymentLogoColor, #7673C0)"
                    fillRule="nonzero"
                    d="M8.829 5.602h6.546v11.765H8.829z"
                ></path>
                <path
                    fill="var(--paymentLogoColor, #EB001B)"
                    fillRule="nonzero"
                    d="M9.247 11.484a7.47 7.47 0 0 1 2.858-5.882 7.482 7.482 0 1 0 0 11.765 7.47 7.47 0 0 1-2.858-5.883z"
                ></path>{' '}
                <path
                    fill="var(--paymentLogoColor, #00A1DF)"
                    fillRule="nonzero"
                    d="M23.583 16.822V16h.156v-.17h-.393V16h.155v.823h.082zm.763 0v-.993h-.119l-.139.71-.138-.71h-.122v.993h.086v-.745l.128.646h.09l.128-.646v.752l.086-.007zm-.138-5.338a7.482 7.482 0 0 1-12.105 5.881 7.482 7.482 0 0 0 0-11.765 7.482 7.482 0 0 1 12.105 5.884z"
                ></path>
            </g>
        </svg>
    );
};

const Py4 = () => {
    return (
        <svg
            height="24"
            width="50"
            fill="none"
            viewBox="0 0 50 24"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: '12px' }}
        >
            <g fill="none" fillRule="evenodd">
                <path
                    fill="var(--paymentLogoColor, #017ECD)"
                    fillRule="nonzero"
                    d="M25.45 11.51v-1.28c0-.5-.5-.99-1-.99h-1.4v2.27h-1.51V5.1h3.7c.9-.1 1.8.5 1.9 1.38v.5c0 .59-.3 1.18-.9 1.47.5.3.8.9.7 1.48v1.58h-1.5zm-2.5-3.75h1.6c.3.1.7-.1.8-.4.1-.29-.1-.68-.4-.78h-2v1.18zm21.33 3.75l-2.4-4.34v4.34h-3.01l-.5-1.38h-2.8l-.5 1.38h-3.21s-2-.3-2-3.06c0-3.35 1.7-3.45 2.4-3.45h1.9v1.48h-1.5c-.7.1-1.2.7-1.1 1.38v.5c0 2.17 2.6 1.48 2.7 1.48L36.16 5h2.1l2.31 5.82V5.1h2.1l2.41 4.24V5.1h1.5v6.51l-2.3-.1zm-8.01-2.96h1.5l-.7-1.87-.8 1.87zm-22.75 2.96V7.07l-1.9 4.44h-1.2l-1.9-4.44v4.44H5.5l-.5-1.38H2.2l-.5 1.38H0L2.5 5h2.1l2.31 5.92V5.1h2.4l1.71 4.04 1.7-4.04h2.4v6.51l-1.6-.1zM2.81 8.55h1.5l-.7-1.87-.8 1.87zm13.12 2.96V5.1h4.7v1.48h-3.2v.99h3.1v1.48h-3.1v1.08h3.2v1.38h-4.7zm11.82.1V5.1h1.5v6.51h-1.5zm3.3 8.3v-1.3c0-.58-.5-.98-1.1-.98h-1.6v2.27h-1.6V13.5h3.9c1-.2 1.9.49 2 1.48v.4c0 .58-.3 1.18-.9 1.47.5.3.8.89.8 1.48v1.58h-1.5zm-2.6-3.76h1.7c.3.1.7-.1.8-.4.1-.29-.1-.68-.4-.78a.3.3 0 0 0-.4 0h-1.7v1.18zm-8.11 3.75h-1.4l-1.7-1.87-1.71 1.87H9.52V13.5h5.9l1.81 2.07 1.9-2.07h5.11c1-.1 1.9.49 2 1.48v.4c0 1.87-.7 2.46-2.8 2.46h-1.6v2.07h-1.5zm-2-3.16l2 2.27v-4.44l-2 2.17zm-7.22 1.78h3.4l1.6-1.78-1.6-1.77h-3.4v.98h3.3v1.48h-3.3v1.09zm10.82-2.37h1.7c.3.1.7-.1.8-.4.1-.29-.1-.68-.4-.78a.3.3 0 0 0-.4 0h-1.7v1.18zm20.14 3.75h-2.9v-1.48h2.5s.9.1.9-.5c0-.58-1.4-.49-1.4-.49-1.1.2-2-.59-2.2-1.57v-.3c-.11-.99.7-1.88 1.7-1.97h3.4v1.38h-2.5s-.9-.2-.9.5c0 .48 1.2.48 1.2.48s2.5-.2 2.5 1.78c.1 1.09-.6 2.07-1.8 2.27h-.4l-.1-.1zm-8.62 0V13.5h5.01v1.48h-3.4v.98h3.3v1.48h-3.3v1.09h3.4v1.38h-5zm14.23 0h-2.9v-1.48h2.5s.9.1.9-.5c0-.58-1.4-.49-1.4-.49-1.1.2-2-.59-2.2-1.67v-.3c-.1-.99.7-1.87 1.7-1.97h3.4v1.48h-2.5s-.9-.2-.9.5c0 .48 1.2.48 1.2.48s2.5-.2 2.5 1.78c.1 1.09-.6 2.07-1.8 2.27h-.4c0-.1 0-.1-.1-.1z"
                ></path>
                <path
                    d="M0 0h50v24H0z"
                    fill="var(--paymentLogoColor, null)"
                ></path>
            </g>
        </svg>
    );
};

const CreditIcon = ({ IconColor }) => {
    return (
        <svg
            height="28px"
            width="28px"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: 'auto' }}
        >
            <path
                d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
                fill={IconColor}
            />
            <path
                d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
                fill={IconColor}
                fillRule="evenodd"
            />
        </svg>
    );
};

const TagIcon = ({ IconColor }) => {
    return (
        <svg
            height="28px"
            width="28px"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: 'auto' }}
        >
            <path
                d="M17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L2.29289 10.7071C2.0976 10.5118 1.99997 10.2558 2 9.99988V5C2 3.34315 3.34315 2 5 2H10.0003C10.2561 2.00007 10.5119 2.0977 10.7071 2.29289L17.7071 9.29289ZM5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z"
                fill={IconColor}
                fillRule="evenodd"
            />
        </svg>
    );
};

const DollarIcon = ({ IconColor }) => {
    return (
        <svg
            height="28px"
            width="28px"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: 'auto' }}
        >
            <path
                d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z"
                fill={IconColor}
            />
            <path
                d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z"
                fill={IconColor}
            />
            <path
                d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z"
                fill={IconColor}
                fillRule="evenodd"
            />
        </svg>
    );
};

const FeatureRow = ({
    color,
    featureText,
    textColor,
    subtitle,
    newFeature = false
}: any) => {
    return (
        <>
            <div style={{ display: 'flex', marginBottom: '16px' }}>
                <CheckIcon color={color} />
                <p
                    style={{
                        marginLeft: '12px',
                        fontFamily: 'Rubik, sans-serif',
                        color: textColor,
                        fontSize: '1.125rem',
                        lineHeight: '1.46',
                        letterSpacing: '0.48px',
                        textDecoration:
                            featureText === 'Limited edition' ? 'underline' : ''
                    }}
                >
                    {featureText}
                </p>
                {subtitle && (
                    <p
                        style={{
                            color: '#FFF',
                            fontSize: '14px',
                            marginTop: '2px',
                            opacity: '0.75',
                            marginLeft: '4px'
                        }}
                    >
                        {subtitle}
                    </p>
                )}
                {newFeature && (
                    <div
                        style={{
                            backgroundColor: 'rgb(68 254 174)',
                            color: 'rgb(8 109 37)',
                            fontWeight: '600',
                            fontSize: '12px',
                            borderRadius: '4px',
                            display: 'inline-flex',
                            padding: '2px 6px',
                            height: '22px',
                            margin: 'auto 0px auto 8px'
                        }}
                    >
                        <p style={{ margin: 'auto' }}>New!</p>
                    </div>
                )}
            </div>
        </>
    );
};

const ChooseButton = ({ cta, textColor, bg }) => {
    const [hoverLink, setHoverLink] = useState(false);

    return (
        <motion.button
            whileHover={{ scale: 1.0375 }}
            whileTap={{ scale: 0.9875 }}
            transition={{ type: 'spring', duration: 0.2 }}
            onHoverStart={(e) => {
                setHoverLink(true);
            }}
            onHoverEnd={(e) => {
                setHoverLink(false);
            }}
            style={{
                padding: '0px',
                cursor: 'pointer',
                marginTop: '24px',
                border: 'none',
                outline: 'none',
                borderRadius: '10px',
                height: '54px',
                color: textColor,
                backgroundColor: bg,
                width: '100%',
                fontSize: '18px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <div
                style={{
                    position: 'relative',
                    display: 'inline-block',
                    margin: '0 auto',
                    // display: 'flex',
                    alignItems: 'center'
                }}
            >
                {hoverLink && (
                    <motion.div
                        initial={{ scale: 0, x: -8 }}
                        animate={{ scale: 1, x: 0 }}
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            position: 'absolute',
                            left: '-24px',
                            top: '0px'
                        }}
                        //transition={{ type: "spring", duration: "0.1s" }}
                    >
                        <ArrowBubble
                            IconColor={textColor}
                            height={'24px'}
                            width={'24px'}
                        />
                    </motion.div>
                )}
                <motion.div
                    animate={{
                        x: hoverLink ? 8 : 0
                        //fontWeight: hoverLink ? "500" : "400",
                    }}
                >
                    {cta}
                </motion.div>
            </div>
        </motion.button>
    );
};

const Switch = ({ toggleSwitch, isOn }) => {
    const spring = {
        type: 'spring',
        stiffness: 700,
        damping: 30
    };
    return (
        <div
            style={{
                minWidth: '70px',
                height: '38px',
                backgroundColor: !isOn ? '#C0DBF7' : '#009FFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: !isOn ? 'flex-start' : 'flex-end',
                borderRadius: '25px',
                padding: '5px',
                cursor: 'pointer'
            }}
            onClick={toggleSwitch}
        >
            <motion.div
                style={{
                    width: '30px',
                    height: '30px',
                    backgroundColor: !isOn ? '#009FFF' : '#FFF',
                    borderRadius: '20px'
                }}
                layout
                transition={spring}
            />
        </div>
    );
};
